import { NavLink } from 'react-router-dom';
import Icon, { type IconName } from './Icon';

interface NavItem {
  label: string;
  to: string;
  icon: IconName;
}

interface NavSection {
  title: string;
  items: NavItem[];
}

const NAV_SECTIONS: NavSection[] = [
  {
    title: 'عمومی',
    items: [{ label: 'داشبورد', to: '/dashboard', icon: 'dashboard' }],
  },
  {
    title: 'اتومیشن',
    items: [
      { label: 'استوری‌ها', to: '/stories', icon: 'story' },
      { label: 'پست‌ها', to: '/posts', icon: 'post' },
      { label: 'هایلایت‌ها', to: '/highlights', icon: 'highlight' },
      { label: 'دایرکت', to: '/dm', icon: 'dm' },
    ],
  },
  {
    title: 'پیام‌ها',
    items: [
      { label: 'صندوق ورودی', to: '/inbox', icon: 'inbox' },
      { label: 'گزارش رویدادها', to: '/logs', icon: 'list' },
      { label: 'تحلیل‌ها', to: '/analytics', icon: 'chart' },
    ],
  },
  {
    title: 'حساب',
    items: [{ label: 'تنظیمات', to: '/settings', icon: 'settings' }],
  },
];

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

export default function Sidebar({ open, onClose }: SidebarProps) {
  return (
    <>
      <aside
        className={`fixed inset-y-0 right-0 z-40 flex w-64 flex-col border-l border-slate-200 bg-white transition-transform duration-200 lg:translate-x-0 ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex h-16 items-center gap-3 border-b border-slate-200 px-5">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-brand-600 to-accent-500 text-sm font-bold text-white">
            ع
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-bold text-slate-900">اتوماسیون اینستاگرام</p>
            <p className="truncate text-xs text-slate-500">پنل مدیریت</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-100 lg:hidden"
            aria-label="بستن منو"
          >
            <Icon name="close" className="h-5 w-5" />
          </button>
        </div>

        <nav className="flex-1 space-y-5 overflow-y-auto p-3">
          {NAV_SECTIONS.map((section) => (
            <div key={section.title}>
              <p className="px-3 pb-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400">
                {section.title}
              </p>
              <div className="space-y-0.5">
                {section.items.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === '/dashboard'}
                    onClick={onClose}
                    className={({ isActive }) =>
                      `flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${
                        isActive
                          ? 'bg-brand-50 font-semibold text-brand-700'
                          : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                      }`
                    }
                  >
                    <Icon name={item.icon} className="h-4.5 w-4.5 shrink-0" />
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>

        <div className="border-t border-slate-200 px-5 py-4 text-xs text-slate-400">
          نسخه ۰٫۲٫۰ — فاز ۳ (بخش‌ها)
        </div>
      </aside>

      {open && (
        <div
          className="fixed inset-0 z-30 bg-slate-950/40 lg:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
    </>
  );
}
